import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { formatHumanDate } from '@/shared/lib';

type Props = {
  value: string;
};

/**
 * Дата со временем в ячейке таблицы c2_eddy. Не поместившаяся в строку делится на строки поровну —
 * дата и время, а не «AM»/«PM» отдельной строкой.
 */
export const C2EddyDateTime: FC<Props> = ({ value }) => {
  const { i18n } = useTranslation();

  return <span className="block text-balance">{formatHumanDate(i18n, value, { withTime: true })}</span>;
};
